import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentReportDto, IncidentWitnessDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { PicturedItemSelectBoxComponent } from '../../../../../../components';
import { ScrollSectionViewComponent } from '../scroll-section-view.component';

@Component({
    selector: 'app-witnesses-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
        PicturedItemSelectBoxComponent,
    ],
    templateUrl: './witnesses-section.component.html',
})
export class WitnessesSectionComponent extends ScrollSectionViewComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() employeesDataSource: any;
    @Input() isReadOnly: boolean = false;

    onWitnessChange(employeeId: any, witness: IncidentWitnessDto) {
        witness.employeeId = employeeId;
    }

    addWitness() {
        this.incidentReport.witnesses.push(
            IncidentWitnessDto.fromJS({
                employeeId: null,
                externalName: '',
                isNotEmployee: false,
            }),
        );
        
        setTimeout(() => {
            this.scrollToSection('witnessSection');
        });
    }

    removeWitness(index: number) {
        this.incidentReport.witnesses.splice(index, 1);
    }

    onWitnessToggle(checked: boolean, witness: IncidentWitnessDto) {
        if (checked) {
            witness.employeeId = null;
        } else {
            witness.externalName = '';
        }
    }
}
